import { Menu, MenuShort } from "~/entities/menuEntities";
import Client from "../baseClient";

export const MenuApi = {
  getMenus: async (orgId: string, siteId: string, orderTypeCode: string) =>
    await Client.get<MenuShort[]>(`${orgId}/${siteId}/menus/${orderTypeCode}`),
  getMenu: async (
    orgId: string,
    siteId: string,
    menuCode: string,
    orderTypeCode: string,
  ) =>
    await Client.get<Menu>(
      `${orgId}/${siteId}/menu/${menuCode}/${orderTypeCode}`,
    ),
};
